import { AssetPreviewTabUsageController } from './asset-preview-tab-usage.controller'

function assetPreviewTabUsage () {
  return {
    restrict: 'E',
    scope: {
      template: '<',
      location: '<'
    },
    templateUrl: '/core/directives/asset-preview-tab-usage/asset-preview-tab-usage.html?$$REVISION$$',
    controller: AssetPreviewTabUsageController
  }
}
export { assetPreviewTabUsage }
